<template>
    <quill-editor ref="quill" v-model="value.content" :options="editorOption"></quill-editor>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import {QuillToolbarDropDown} from "@/utilities/dynamic-quill-tools"

export default {
    props:{
        value:Object,
        parameters:Object,
    },
    components: {
        quillEditor,
    },
    mounted(){
        let quill = this.$refs.quill.quill 

        const myDropDown = new QuillToolbarDropDown({
            label: "Sistem Değişkenleri",
            rememberSelection: false
        })

        myDropDown.setItems(this.parameters)

        myDropDown.onSelect = function(label, value, quill) {
            const { index, length } = quill.selection.savedRange
            quill.deleteText(index, length)
            quill.insertText(index, value)
            quill.setSelection(index + value.length)
        }

        myDropDown.attach(quill)
    },
    data(){
        return{
            editorOption:{
                placeholder:"",
                modules:{
                    toolbar:[
                        ['bold', 'italic', 'underline', 'strike'],                
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],   
                        [{ 'indent': '-1'}, { 'indent': '+1' }],     
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'font': [] }],
                        [{ 'align': [] }],
                        ['clean']
                    ]
                }
            }
        }
    },
}
</script>

<style>
.quill-editor{
    height: 100%;
    display: flex;
    flex-direction: column;
}
.ql-container.ql-snow{
    border: 0px;
    height: calc(100% - 42px);
}
</style>